<template lang="pug">
  div
    .heading Traceroute
    .subtitle This page allows you to perform a traceroute to a given address.
    TracerouteLookup
</template>
<script>
import TracerouteLookup from "@/components/TracerouteLookup";

export default {
  components: {
    TracerouteLookup: TracerouteLookup,
  },
};
</script>
